/**
 * The action bar docked below a PopoverCard's body.
 *
 * One definition so every popover's footer shares the design's divider, white fill and 18px of padding
 * around its actions, whether it arrives through PopoverCard's `footer` slot or is pinned inside a
 * self-contained view that fills the body. Overall height follows whatever controls it holds.
 */
export default function PopoverFooter({
  children,
  align = 'stretch'
}: {
  children: React.ReactNode;
  /** 'end' right-aligns an action pair; 'stretch' suits a single full-width button. */
  align?: 'end' | 'stretch';
}) {
  return (
    <div
      className={`shrink-0 border-t bg-white px-4 py-[18px] ${
        align === 'end' ? 'flex items-center justify-end gap-2' : ''
      }`}
    >
      {children}
    </div>
  );
}
